<!-- eslint-disable -->
<template lang="pug">
    .game-content
        games-wrapper(
            :type="type",
            :exercise-id="exerciseId",
            :homework-id="homeworkId",
            :players-number="1",
        )
</template>

<script>
    /*eslint-disable*/
    import GamesWrapper from '../GamesWrapper.vue'
    export default {
        props: ['exerciseId', 'homeworkId', 'type'],
        components: {
            GamesWrapper
        },
        beforeRouteLeave (to, from, next) {
            if (this.$store.state.games.puzzle) {
                let fromGameToSettings = from.name === 'puzzle:start' && to.name === 'games:settings';
                if (!(to.meta.type && to.meta.type === 'games') && !fromGameToSettings) {
                    this.$store.dispatch('setHomework', null);
                    //this.$store.dispatch('setPuzzleGame', null);
                }
            }
            next();
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/main.scss";
</style>
